// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultLayout_wrapper__snYa7","content":"DefaultLayout_content__VGjpR"};